"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixUnicodeTextLayout = fixUnicodeTextLayout;
const text_measurement_1 = __importDefault(require("./text-measurement"));
const tex_syntax_1 = require("./tex-syntax");
const textNodes = `\\\\text(\\s*${(0, tex_syntax_1.block)(4)})`;
const currencySymbols = "[¢\\u20a0-\\u20c0]";
const linebreaks = "\\\\\\\\";
const linebreaksTextNodesAndCurrencySymbols = new RegExp(`(?:${linebreaks}|${textNodes}|${currencySymbols})`, "g");
function fixUnicodeTextLayout(tex) {
    return tex.replace(linebreaksTextNodesAndCurrencySymbols, (match, arg) => {
        if (match === "\\\\") {
            return match;
        }
        if (match.startsWith("\\text")) {
            for (const char of match) {
                if (isNonAsciiUnicode(char)) {
                    // HACK: This use of `\hphantom.` works around a bug
                    // (possibly https://github.com/mathjax/MathJax/issues/3056)
                    // in MathJax. It seems that if MathJax thinks the argument
                    // of `rlap` has zero width, MathJax will assume that `rlap`
                    // has no effect and omit it. You can see the effects of
                    // this bug by removing `\hphantom.` and looking at
                    // /devadmin/tex/testcases, but the summary is, it creates
                    // a lot of blank space to the right of every \text node
                    // that contains unicode. Adding `\hphantom` causes the
                    // argument of `\rlap` to have nonzero width, so MathJax
                    // keeps it.
                    //
                    // The choice of `.` as the argument to `\\hphantom` is
                    // arbitrary; any argument with nonzero width would do.
                    return `{\\rlap{${match}\\hphantom.}\\phantom{\\text${replaceUnicodeWithSpacing(arg)}}}`;
                }
            }
            // If we didn't find any unicode, no need to replace anything.
            return match;
        }
        // Else, we're replacing a currency symbol that's not inside a \text
        // node.
        return `{\\rlap{${match}\\hphantom.}${equivalentSpacing(match)}}`;
    });
}
function replaceUnicodeWithSpacing(text) {
    return text.replace(/[^\t\n\r\x20-\x7f]+/g, equivalentSpacing);
}
function equivalentSpacing(s) {
    return `\\kern{${text_measurement_1.default.measureWidthInEms(s)}em}`;
}
function isNonAsciiUnicode(char) {
    const maxAsciiCodePoint = 127;
    const codePoint = char.codePointAt(0);
    return codePoint != null && codePoint > maxAsciiCodePoint;
}
